<template>
  <div class="l_stamp_history">
    <div class="container">
      <div class="content ">
        <div class="ranks">
          <div class="rank" v-if="stampData != null">
            <div class="header">
              <span
                >{{ dataFormat(stampData.from) }} 〜
                {{ dataFormat(stampData.to) }}</span
              >
              <div class="close" v-on:click="goBack">
                <font-awesome-icon icon="times" />
              </div>
            </div>
            <div class="body">
              <StampHistoryTitle :stampData="stampData" />

              <div class="carousel-wapper">
                <carousel
                  :perPage="1"
                  :paginationActiveColor="'#602209'"
                  :paginationPosition="'bottom'"
                  :paginationPadding="2"
                  :navigate-to="page"
                  @pageChange="changePage"
                >
                  <slide
                    v-for="(stampCard, idx) in validCards"
                    :key="stampCard.stamp_start_num"
                  >
                    <StampHistoryCardBody
                      :stampCard="stampCard"
                      v-if="stampData.current_stamp_card >= idx"
                    />
                  </slide>
                </carousel>
                <div class="links">
                  <div
                    @click="before"
                    v-bind:class="{ invisible: isFirstPage }"
                  >
                    <font-awesome-icon icon="chevron-left" /> 前のカード
                  </div>
                  <div @click="next" v-bind:class="{ invisible: isLastPage }">
                    次のカード
                    <font-awesome-icon icon="chevron-right" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel' // import slider components
import { mapActions, mapGetters } from 'vuex'
import {
  sumStampCount,
  rankName,
  rankLabel,
  rankMark,
  rankColor,
  cardBackColor,
  dataFormat
} from '../utils/StampUtil.js'
import StampHistoryCardBody from './StampHistory/CardBody'
import StampHistoryTitle from './StampHistory/YearlyRankTitle'
import DateFormatter from '../utils/DateFormatter.js'
import { FactoryTrack } from '@/constant/firebase'

export default {
  name: 'StampHistory',
  components: {
    Carousel,
    Slide,
    StampHistoryCardBody,
    StampHistoryTitle
  },
  data: function() {
    return {
      id: 0,
      page: 0,
      stampData: null,
      rankLabel
    }
  },
  created() {
    document.title = 'スタンプ獲得履歴詳細'
    const accTime = new DateFormatter().format(new Date())
    try {
      window.receivedToken = payload => {
        const json = JSON.parse(payload)
        this.fetchStampHistory(json.app_token, accTime, json.user_id)
        window.receivedToken = null
      }
      // クーポン一覧と同じなので一旦apiTypeを3に設定する
      this.actionRequestToken({
        apiType: '3',
        acc_time: accTime
      })
    } catch (e) {
      console.log(e)
    }
  },
  mounted() {
    this.stampData = this.pastHistories[this.$route.params.id].stamp_data
  },
  computed: {
    ...mapGetters({
      histories: 'Stamp/histories'
    }),
    isFirstPage: function() {
      return this.page === 0
    },
    isLastPage: function() {
      return (
        this.stampData == null ||
        this.page === this.stampData.current_stamp_card - 1
      )
    },
    validCards: function() {
      if (this.stampData === null) {
        return []
      }
      const count = this.stampData.current_stamp_card
      return this.stampData.stamp_cards.slice(0, count)
    },
    pastHistories: function() {
      return this.histories || []
    }
  },
  methods: {
    ...mapActions('Analytics', ['trackEvent']),
    ...mapActions('Native', ['actionRequestToken']),
    ...mapActions('Loading', ['actionToggleLoading']),
    ...mapActions('Stamp', ['actionFetchStampHistory']),
    async fetchStampHistory(token, accTime, userId) {
      try {
        this.actionToggleLoading(true)

        await this.actionFetchStampHistory({
          token: token,
          accTime: accTime,
          userId: userId
        })
        this.stampData = this.pastHistories[this.$route.params.id].stamp_data
        this.mounted = true
      } catch (e) {
        this.errorMessage = e.message
        this.errorTitle = 'エラー' + e.code
        this.errorCode = e.code
        this.isError = true
        console.error(e)
      }
      this.actionToggleLoading(false)
    },

    sumStampCount,
    rankName,
    rankMark,
    rankColor,
    cardBackColor,
    dataFormat,
    changePage: function(page) {
      this.trackEvent(FactoryTrack.createPageChange('スタンプ獲得履歴詳細', page))
      this.page = page
    },

    before: function() {
      if (!this.isFirstPage) this.page--
      this.trackEvent(FactoryTrack.createPrevPage('スタンプ獲得履歴詳細', this.page))
    },
    next: function() {
      if (!this.isLastPage) this.page++
      this.trackEvent(FactoryTrack.createNextPage('スタンプ獲得履歴詳細', this.page))
    },
    imageUrl: (stamps, idx) =>
      stamps.length > idx ? stamps[idx].image_url : '',
    stampedAt: (stamps, idx) =>
      stamps.length > idx ? stamps[idx].stamped_at : '',
    goBack: function() {
      this.trackEvent(FactoryTrack.createHistoryBack())
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
.l_stamp_history {
  width: 100%;
  min-height: 100%;
  background-color: #333333;
  height: 100vh;

  display: flex;
  align-items: center;

  .content {
    text-align: left;
    width: 100vw;

    .invisible {
      visibility: hidden;
    }

    .links {
      width: 100%;
      display: flex;
      justify-content: space-between;
      margin: 10px 0;
      padding: 0 20px;

      div {
        color: #7c4934;
        font-weight: bold;
        text-decoration: none;
      }
    }

    .ranks {
      .rank {
        border-radius: 5px;
        overflow: hidden;
        margin: 0 10px;

        .header {
          display: flex;
          width: 100%;
          justify-content: center;
          align-items: center;
          background-color: #deaa03;
          color: #ffffff;
          font-size: 4vw;
          font-weight: bold;
          height: 40px;
          position: relative;

          .close {
            position: absolute;
            right: 10px;
          }
        }

        .body {
          background-color: #ffffff;
          display: flex;
          flex-direction: column;
          width: 100%;
          justify-content: space-evenly;
          align-items: center;

          .carousel-wapper {
            width: 100%;
            margin-top: 20px;
          }
        }
      }
    }
  }
}
</style>
